import React, { Component } from "react";
import {
  formatoSeparadorMilesValue,
  formatoSeparadorMilesReturn,
} from "../../generico/utils/FormatoInput";

const tipoObligacion = {
  aporte: "APORTE",
  solidaridad: "SOLIDARIDAD",
  sepelio: "SEPELIO"
};

export default class SeleccionImportePago extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() { }

  obtenerDeudaTotal() {
    return (
      formatoSeparadorMilesValue(this.props.deudaTotal) +
      " " +
      this.props.moneda +
      "."
    );
  }

  obtenerDeudaAFecha() {
    return (
      formatoSeparadorMilesValue(this.props.deudaHoy) +
      " " +
      this.props.moneda +
      "."
    );
  }

  insertarDeudaTotal() {
    document.getElementById("importe_pagar").value = formatoSeparadorMilesValue(
      this.props.deudaTotal
    );
    this.props.returnImporte(formatoSeparadorMilesValue(this.props.deudaTotal));
  }
  insertarDeudaAFecha() {
    document.getElementById("importe_pagar").value = formatoSeparadorMilesValue(
      this.props.deudaHoy
    );
    this.props.returnImporte(formatoSeparadorMilesValue(this.props.deudaHoy));
  }

  handleChangeImporte = (evt) => {
    var _monto = formatoSeparadorMilesReturn(evt);
    if (_monto.length > 1 && _monto.substr(0, 1) === "0") {
      _monto = _monto.substr(1);
    }
    this.props.returnImporte(_monto);
  };

  render() {
    return (
      <div className="form-group">
        <label className="input-label-bold">Ingrese el Importe a Pagar *</label>

        <input
          value={this.props.importe}
          type="text"
          id="importe_pagar"
          onChange={this.handleChangeImporte}
          maxLength="19"
          className="form-control input-box"
        />

        {/* <div className="row">
          <div className="col-md-6">
          <button
          className="btn btn-cu-largo-primary"
          onClick={() => this.insertarDeudaAFecha()}
        >
          Pagar Deuda a la Fecha: {this.obtenerDeudaAFecha()}
        </button>
          </div>
          <div className="col-md-6">
          <button
          className="btn btn-cu-largo-secundary" */}

        <div className="row">
          <div className="col-lg-6 col-md-6 col-12">
          {this.props.tipoObligacion !== "SEPELIO" &&
          <button
            className="btn btn-cu-primary btn-consulta"
            style={{marginTop: 15 }}
            onClick={() => this.insertarDeudaAFecha()}
          >
            Pagar Deuda a la Fecha: {this.obtenerDeudaAFecha()}
          </button>
        }
          </div>
          <div className="col-lg-6 col-md-6 col-12">
          <button
          className="btn btn-cu-primary btn-consulta"

          style={{ marginTop: 15 }}
          onClick={() => this.insertarDeudaTotal()}>
          Pagar Deuda Total: {this.obtenerDeudaTotal()}
        </button>
          </div>
        </div>
        
          </div>



    );
  }
}
